<template>
    <div>
        <!-- 编辑、添加界面 -->
        <el-dialog v-dialog-drag :title="title" :visible.sync="showDialog" width="1100px" :destroy-on-close="true"
            :before-close="cancel">
            <div class="el-dialog-div">
                <el-form class="formDiv" label-width="125px" ref="form" :model="form">
                    <!-- 终止范围选择：整合同 / 部分项目 -->
                    <!-- <el-form-item label="终止范围" prop="contractTerminateFlag"
                        :rules="{ required: true, message: '请选择终止范围', trigger: 'change' }">
                        <el-radio-group v-model="form.contractTerminateFlag">
                            <el-radio :label="true">合同终止</el-radio>
                            <el-radio :label="false">实验终止</el-radio>
                        </el-radio-group>
                    </el-form-item> -->
                    <el-form-item style="width: 89%!important;" label="终止原因" prop="reasonForTermination"
                        :rules="{ required: true, message: '请输入终止原因', trigger: 'change' }">
                        <el-input :autosize="{ minRows: 3 }" type="textarea" placeholder="请输入内容"
                            v-model="form.reasonForTermination" maxlength="300" show-word-limit>
                        </el-input>
                    </el-form-item>
                </el-form>
                <el-form class="formDiv" label-width="125px" ref="formContract" :model="formContract"
                    :class="{ 'disabled-state': form.contractTerminateFlag }">
                    <el-form-item label="合同编号" prop="contractNumber">
                        <div style="display:flex;align-items: center">
                            <el-input style="width: 330px;" v-model="formContract.contractNumber" auto-complete="off"
                                disabled :readonly=true placeholder="请获取合同编号">
                            </el-input>
                        </div>
                    </el-form-item>
                    <el-form-item label="有效期限" prop="expirationDate">
                        <el-select style="width: 330px;" disabled v-model="formContract.expirationDate"
                            placeholder="请选择有效期限" filterable>
                            <el-option v-for="item in DateOptions" :key="item.label" :label="item.name"
                                :value="item.label"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="合同名称" prop="contractName" style="width: 45%!important;">
                        <div style="display:flex;align-items: center">
                            <el-input style="width: 330px;" v-model="formContract.contractName" auto-complete="off"
                                placeholder="请输入合同名称" disabled></el-input>
                        </div>
                    </el-form-item>
                    <el-form-item label="合同金额" prop="contractAmount" style="width: 50%!important;"
                        :rules="[{ required: !form.contractTerminateFlag, message: '请输入合同金额', trigger: 'change' },
                         { validator: (rule, value, callback) => checkMinMax(rule, value, callback, 0, Number(selectDetail.contractAmount)), trigger: 'change' }]">
                        <div style="display:flex;align-items: center">
                            <el-input style="width: 330px;" v-model="formContract.contractAmount" auto-complete="off"
                                placeholder="请输入合同金额"></el-input>
                            <el-button type="success" style="margin-left: 10px" size="mini"
                                @click="addAllAmount">累加</el-button>
                        </div>
                    </el-form-item>
                    <el-form-item label="合同拟定时间" prop="contractDraftingDate">
                        <el-input style="width: 330px;" v-model="formContract.contractDraftingDate" disabled
                            auto-complete="off" placeholder="请输入日期，格式yyyy-MM-dd"></el-input>
                    </el-form-item>
                    <el-form-item label="销售" prop="salesId">
                        <el-select style="width: 330px;" v-model="formContract.salesId" placeholder="请选择" filterable
                            disabled>
                            <el-option v-for="item in DrafterOptions" :key="item.uuid" :label="item.name"
                                :value="item.uuid"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="甲方项目联系人" prop="customerContactsId"
                        v-if="formContract.contractType !== 'DEVELOPMENT'">
                        <el-select style="width: 330px;" v-model="formContract.customerContactsId"
                            placeholder="请先选择甲方项目联系人" filterable disabled>
                            <el-option v-for="item in UserOptions" :key="item.id"
                                :label="item.contactName + '-' + item.companyName" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="乙方(受托方)" prop="trusteeCompanyId">
                        <el-select style="width: 330px;" v-model="formContract.trusteeCompanyId" placeholder="请选择"
                            filterable disabled>
                            <el-option v-for="item in businessOption" :key="item.id" :label="item.companyName"
                                :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="乙方项目联系人" prop="trusteeContactsId"
                        v-if="formContract.contractType !== 'DEVELOPMENT'">
                        <el-select style="width: 330px;" v-model="formContract.trusteeContactsId" placeholder="请选择"
                            filterable disabled>
                            <el-option v-for="item in DrafterOptions" :key="item.uuid" :label="item.name"
                                :value="item.uuid"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="合同分类" prop="contractType">
                        <el-select style="width: 330px;" v-model="formContract.contractType" placeholder="请选择合同分类"
                            filterable disabled>
                            <el-option v-for="item in TypeOptions" :key="item.label" :label="item.name"
                                :value="item.label"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="合同类型" prop="projectType">
                        <el-select style="width: 330px;" v-model="formContract.projectType" placeholder="请选择合同类型"
                            filterable disabled>
                            <el-option v-for="item in DirectionOptions" :key="item.label" :label="item.label"
                                :value="item.label"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="签订地点" prop="signingPlace">
                        <el-input placeholder="请输入签订地点" style="width: 330px;" disabled
                            v-model="formContract.signingPlace">
                        </el-input>
                    </el-form-item>
                    <div v-if="['预付款扣款（测序分析）', '预付款扣款（裸测）', '测序分析', '裸测'].includes(formContract.projectType) && formContract.contractType !== 'DEVELOPMENT'"
                        style="width: 100%">
                        <div style="display:flex;width: 100%">
                            <el-form-item label="是否返样" prop="returnFlag"
                                :rules="[{ required: form.checkProject.length > 0, message: '请选择是否返样', trigger: 'change' }]">
                                <el-select style="width: 330px;" v-model="formContract.returnFlag" placeholder="请选择是否返样"
                                    filterable :disabled="form.checkProject.length<=0">
                                    <el-option v-for="item in flagOption" :key="item.value" :label="item.label"
                                        :value="item.value"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="服务费(返样)" prop="sampleAmount" v-if="formContract.returnFlag === true"
                                :rules="[{ required: form.checkProject.length > 0, message: '请输入服务费(返样)', trigger: 'change' },
                                { validator: (rule, value, callback) => checkMinMax(rule, value, callback, 0, ''), trigger: 'change' }]">
                                <el-input style="width: 330px;" v-model="formContract.sampleAmount" auto-complete="off"
                                    :disabled="form.checkProject.length <= 0"></el-input>
                            </el-form-item>
                        </div>
                        <el-form-item label="金额为0原因" prop="reason" v-if="Number(formContract.sampleAmount) === 0 && formContract.returnFlag === true
                            && formContract.sampleAmount !== ''" style="width: 89%!important;"
                            :rules="[{ required: form.checkProject.length > 0, message: '请填写服务费(返样)为0的原因', trigger: 'change' }]">
                            <el-input :autosize="{ minRows: 3 }" type="textarea" placeholder="请填写服务费(返样)为0的原因"
                                v-model="formContract.reason" :disabled="form.checkProject.length <= 0" maxlength="300"
                                show-word-limit>
                            </el-input>
                        </el-form-item>
                    </div>
                    <el-form-item v-if="formContract.contractType === 'PREPAYMENTS'" label="增值金额" prop="addedAmount">
                        <el-input style="width: 330px;" v-model="formContract.addedAmount" auto-complete="off"
                            disabled></el-input>
                    </el-form-item>
                    <el-form-item label="样品处理方式" prop="sampleManagement" v-if="['返样/暂存样品', '预付款扣款（返样/暂存样品）'].includes(formContract.projectType)">
                        <template #label>
                            <span style="background-color: #ffff00;color: #ff1c00;font-weight: bold;">样品处理方式</span>
                        </template>
                        <el-radio-group v-model="formContract.sampleManagement" disabled>
                            <el-radio label="RETURN_SAMPLE">返样</el-radio>
                            <el-radio label="SAMPLE_HOLD">暂存样品</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <div style="width: 100%;margin-bottom: 20px">
                        <el-checkbox-group v-model="form.checkProject">
                            <div style="display:flex;align-items: center;"
                                v-if="projectTypeData.includes(formContract.projectType)"
                                v-for="(project, index) in formContract.specificProjectType" :key="index">
                                <div :class="{ 'disabled-state': project.projectStatus === 'TERMINATION' }"
                                    style="display: flex;flex-wrap: wrap;padding-top:20px;border: 1px dashed #d9d9d9;width: 90%!important;">
                                    <el-form-item style="width: 32%!important;"></el-form-item>
                                    <el-form-item style="width: 32%!important;"></el-form-item>
                                    <el-form-item label="最终结算金额"
                                        :prop="'specificProjectType.' + index + '.projectNewAmount'"
                                        style="width: 32%!important;"
                                        :rules="[{ required: form.checkProject.includes(project), message: '请输入最终结算金额', trigger: 'change' },
                                         { validator: (rule, value, callback) => checkMinMax(rule, value, callback, 0, ''), trigger: 'change' }]">
                                        <div style="display: flex;align-items: center">
                                            <el-input v-model="project.projectNewAmount" auto-complete="off"
                                                :disabled="!form.checkProject.includes(project) || isExperimentalProject(project)"
                                                placeholder="请输入最终结算金额"></el-input>
                                        </div>
                                    </el-form-item>
                                    <el-form-item label="项目模块" style="width: 32%!important;"
                                        :prop="'specificProjectType.' + index + '.projectClassification'">
                                        <el-select v-model="project.projectClassification" placeholder="请选择项目模块"
                                            filterable disabled>
                                            <el-option
                                                v-for="item in TypeOption.filter(item => !item.disabled.includes(formContract.projectType))"
                                                :key="item.label" :label="item.name" :value="item.label"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item :label="project.projectClassification !== '硬盘购买' ? '项目类型' : '硬盘大小'"
                                        style="width: 32%!important;"
                                        :prop="'specificProjectType.' + index + '.projectType'">
                                        <el-select v-model="project.projectType" placeholder="请选择项目类型" filterable
                                            disabled>
                                            <el-option
                                                v-for="item in filterOptions(project.projectClassification, project.projectType)"
                                                :disabled="item.deprecated" :key="item.name" :label="item.name"
                                                :value="item.name"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="项目原金额" style="width: 32%!important;">
                                        <div style="display: flex;align-items: center">
                                            <el-input v-model="project.projectAmount" auto-complete="off" disabled
                                                placeholder="请输入项目金额"></el-input>
                                        </div>
                                    </el-form-item>
                                    <div style="width: 100%!important;display: flex;justify-content: center;"
                                        v-if="project.experimental && project.experimental.length > 0">
                                        <div style="width: 98%;border:1px dashed #d9d9d9;padding: 15px 20px 5px 20px;">
                                            <el-form-item label="实验过程"
                                                :prop="'specificProjectType.' + index + '.labList'"
                                                style="width: 100%!important;margin-bottom: 0" label-width="135px">
                                                <!-- 列标题 -->
                                                <div style="display:flex;align-items:center;margin-bottom:10px;font-weight:600;color:#606266;font-size:13px;">
                                                    <span style="width:150px;flex-shrink:0;"></span>
                                                    <span style="flex:1;min-width:0;text-align:center;padding:0 8px;">数量</span>
                                                    <span style="flex:1;min-width:0;text-align:center;padding:0 8px;">原金额</span>
                                                    <span style="flex:1;min-width:0;text-align:center;padding:0 8px;">最终结算金额</span>
                                                </div>
                                                <el-checkbox-group v-model="project.labList" style="width:100%"
                                                    disabled>
                                                    <div v-for="(lab, labIndex) in project.experimental" :key="labIndex"
                                                        style="display:flex;align-items:center;width:100%;margin-bottom:12px;">
                                                        <el-checkbox :label="lab.experimentName"
                                                            :disabled="['引物合成', '荧光定量'].includes(lab.experimentName) && project.labList.includes(lab.experimentName)"
                                                            style="width:150px;flex-shrink:0;margin:0;">{{ lab.experimentName }}</el-checkbox>
                                                        <!-- 数量（只读） -->
                                                        <div style="flex:1;min-width:0;padding:0 8px;">
                                                            <el-input v-model="lab.numberOfExperiment"
                                                                auto-complete="off" placeholder="数量" disabled></el-input>
                                                        </div>
                                                        <!-- 原金额（只读） -->
                                                        <div style="flex:1;min-width:0;padding:0 8px;">
                                                            <el-input :value="lab.originalExperimentAmount"
                                                                auto-complete="off" placeholder="原金额" disabled></el-input>
                                                        </div>
                                                        <!-- 最终结算金额（可编辑） -->
                                                        <el-form-item label-width="0"
                                                            style="flex:1;min-width:0;width:auto!important;margin-bottom:0;padding:0 8px;"
                                                            :prop="'specificProjectType.' + index + '.experimental.' + labIndex + '.experimentAmount'"
                                                            :rules="[{ required: form.checkProject.includes(project) && isSettleableExperiment(project, lab.experimentName), message: '请输入结算金额', trigger: 'change' },
                                                            { validator: (rule, value, callback) => checkExperimentAmount(rule, value, callback, lab.originalExperimentAmount), trigger: 'change' }]">
                                                            <el-input v-model="lab.experimentAmount"
                                                                auto-complete="off" placeholder="最终结算金额"
                                                                :disabled="!form.checkProject.includes(project) || !isSettleableExperiment(project, lab.experimentName)"
                                                                @change="handleExperimentAmountChange(project)"></el-input>
                                                        </el-form-item>
                                                    </div>
                                                </el-checkbox-group>
                                            </el-form-item>
                                        </div>
                                    </div>
                                    <div style="width: 100%;margin-bottom: 20px"
                                        v-if="!(project.experimental && project.experimental.length > 0)">
                                        <div v-for="(dataItem, dataIndex) in project.projectSampleDataList"
                                            :class="['custom-style']">
                                            <div
                                                :style="{ display: 'flex', width: '98%', 'align-items': 'flex-start', 'flex-wrap': 'wrap', 'border': '1px dashed #d9d9d9', 'border-top-style': dataIndex !== 0 ? 'none' : 'dashed', }">
                                                <el-form-item label="样品数量"
                                                    :prop="'specificProjectType.' + index + '.projectSampleDataList.' + dataIndex + '.numberOfSamples'"
                                                    style="width: 32%!important;margin-top: 10px;">
                                                    <div style="display: flex;align-items: center">
                                                        <el-input v-model="dataItem.numberOfSamples" auto-complete="off"
                                                            placeholder="请输入样品数量" disabled></el-input>
                                                    </div>
                                                </el-form-item>
                                                <!-- 二代/三代检测平台可选时，宽度为66% -->
                                                <div style="display: flex; flex-wrap: wrap; width: 68%;">
                                                    <div v-for="(info, sonIndex) in dataItem.projectList"
                                                        :key="sonIndex" v-if="info.value !== 'NOT'"
                                                        :style="{ display: 'flex', alignItems: 'center', width: ((info.name === '二代' && project.sequencingPlatformList && project.sequencingPlatformList.length > 0) || (info.name === '三代' && project.thirdSequencingPlatformList && project.thirdSequencingPlatformList.length > 0)) ? '98%' : '49%', marginTop: '15px' }">
                                                        <el-form-item :label="info.name + '数据量'"
                                                            :prop="'specificProjectType.' + index + '.projectSampleDataList.' + dataIndex + '.projectList.' + sonIndex + '.size'"
                                                            :style="{ width: ((info.name === '二代' && project.sequencingPlatformList?.length > 0) || (info.name === '三代' && project.thirdSequencingPlatformList?.length > 0)) ? '48%!important' : '99%!important' }">
                                                            <el-input v-model="info.size" auto-complete="off" disabled
                                                                placeholder="请输入">
                                                                <template #suffix>
                                                                    <span style="color: #606266;margin-right: 3px;">{{
                                                                        '(' +
                                                                        project.dataAmountUnit + ')' }}</span>
                                                                </template>
                                                            </el-input>
                                                        </el-form-item>
                                                        <!-- 二代检测平台选择 -->
                                                        <el-form-item
                                                            v-if="info.name === '二代' && project.sequencingPlatformList && project.sequencingPlatformList.length > 0"
                                                            label="检测平台"
                                                            :prop="'specificProjectType.' + index + '.sequencingPlatform'"
                                                            style="width: 48%!important;">
                                                            <el-select v-model="project.sequencingPlatform"
                                                                placeholder="请选择二代检测平台" disabled filterable>
                                                                <el-option
                                                                    v-for="item in project.sequencingPlatformList"
                                                                    :key="item" :label="item" :value="item"></el-option>
                                                            </el-select>
                                                        </el-form-item>
                                                        <!-- 三代检测平台选择 -->
                                                        <el-form-item
                                                            v-if="info.name === '三代' && project.thirdSequencingPlatformList && project.thirdSequencingPlatformList.length > 0"
                                                            label="检测平台"
                                                            :prop="'specificProjectType.' + index + '.thirdSequencingPlatform'"
                                                            style="width: 48%!important;">
                                                            <el-select v-model="project.thirdSequencingPlatform"
                                                                placeholder="请选择三代检测平台" disabled filterable>
                                                                <el-option
                                                                    v-for="item in project.thirdSequencingPlatformList"
                                                                    :key="item" :label="item" :value="item"></el-option>
                                                            </el-select>
                                                        </el-form-item>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                    <div style="width: 100%!important;display: flex;flex-wrap: wrap;"
                                        v-if="!['预付款扣款（裸测）', '裸测'].includes(formContract.projectType)">
                                        <el-form-item label="分析要求" :prop="'specificProjectType.' + index + '.analysis'"
                                            style="width: 49%!important;"
                                            v-if="project.projectClassification && project.projectClassification !== '硬盘购买'"
                                            label-width="135px">
                                            <el-radio-group v-model="project.analysis" disabled>
                                                <el-radio label="标准分析">标准分析</el-radio>
                                                <el-radio label="非标准分析">非标准分析</el-radio>
                                            </el-radio-group>
                                        </el-form-item>

                                        <el-form-item label="解离样品投递方式" style="width: 49%!important;" label-width="135px"
                                            prop="protectiveFluidInfo.protectiveFluidMethod"
                                            v-if="['单细胞解离转录组-C4', '单细胞解离转录组-10X', '单细胞解离转录组'].includes(project.projectType)">
                                            <el-radio-group disabled
                                                v-model="formContract.protectiveFluidInfo.protectiveFluidMethod">
                                                <el-radio label="DOOR">上门</el-radio>
                                                <el-radio label="MAIL">邮寄</el-radio>
                                            </el-radio-group>
                                        </el-form-item>
                                       
                                        <div v-if="['单细胞解离转录组-C4', '单细胞解离转录组-10X', '单细胞解离转录组'].includes(project.projectType)"
                                            style="margin-top: 5px;width: 100%;display: flex;flex-wrap: wrap;">
                                            <template
                                                v-if="formContract.protectiveFluidInfo.protectiveFluidMethod === 'DOOR'">
                                                <el-form-item label="上门时间" style="width: 48%!important;"
                                                    prop="protectiveFluidInfo.doorInfo.doorTime">
                                                    <el-input disabled
                                                        v-model="formContract.protectiveFluidInfo.doorInfo.doorTime"
                                                        auto-complete="off" placeholder="请输入日期，格式yyyy-MM-dd"></el-input>
                                                </el-form-item>
                                                <el-form-item :label="'上门费用'" style="width: 48%!important;"
                                                    prop="protectiveFluidInfo.doorInfo.doorFee">
                                                    <el-input  disabled
                                                        v-model="formContract.protectiveFluidInfo.doorInfo.doorFee"
                                                        auto-complete="off" placeholder="请输入上门费用">
                                                    </el-input>
                                                    <template #label>
                                                        <span>上门费用</span>
                                                        <!-- 可以根据需求调整对齐方式：text-align: flex-end 为右对齐 -->
                                                        <span
                                                            style="font-size: 12px; color: #606266; margin-top: 2px;">&ge;3000</span>
                                                    </template>
                                                </el-form-item>
                                                <el-form-item label="联系方式" style="width: 48%!important;"
                                                    prop="protectiveFluidInfo.doorInfo.phone">
                                                    <el-input v-model="formContract.protectiveFluidInfo.doorInfo.phone"                                                         disabled
                                                        auto-complete="off" placeholder="请输入联系方式"></el-input>
                                                </el-form-item>
                                                <el-form-item label="上门地址" style="width: 48%!important;"
                                                    prop="protectiveFluidInfo.doorInfo.address">
                                                    <el-input disabled
                                                        v-model="formContract.protectiveFluidInfo.doorInfo.address"
                                                        auto-complete="off" placeholder="请输入上门地址"></el-input>
                                                </el-form-item>
                                            </template>
                                            <template
                                                v-else-if="formContract.protectiveFluidInfo.protectiveFluidMethod === 'MAIL'">
                                                <el-form-item label="邮寄时间" style="width: 48%!important;"
                                                    prop="protectiveFluidInfo.materialMailInfo.mailTime">
                                                    <el-input disabled
                                                        v-model="formContract.protectiveFluidInfo.materialMailInfo.mailTime"
                                                        auto-complete="off" placeholder="请输入日期，格式yyyy-MM-dd"></el-input>
                                                </el-form-item>
                                                <el-form-item label="收件人" style="width: 48%!important;"
                                                    prop="protectiveFluidInfo.materialMailInfo.recipient">
                                                    <el-input disabled
                                                        v-model="formContract.protectiveFluidInfo.materialMailInfo.recipient"
                                                        auto-complete="off" placeholder="请输入收件人"></el-input>
                                                </el-form-item>
                                                <el-form-item label="收件人电话" style="width: 48%!important;"
                                                    prop="protectiveFluidInfo.materialMailInfo.phone">
                                                    <el-input disabled
                                                        v-model="formContract.protectiveFluidInfo.materialMailInfo.phone"
                                                        auto-complete="off" placeholder="请输入收件人电话"></el-input>
                                                </el-form-item>
                                                <el-form-item label="收件地址" style="width: 48%!important;"
                                                    prop="protectiveFluidInfo.materialMailInfo.address">
                                                  <el-input  disabled
                                                        v-model="formContract.protectiveFluidInfo.materialMailInfo.address"
                                                        auto-complete="off" placeholder="请输入收件地址"></el-input>
                                                </el-form-item>
                                            </template>
                                        </div>

                                        <el-form-item label="标准分析具体类型"
                                            :prop="'specificProjectType.' + index + '.analysisList'"
                                            style="width: 98%!important;" label-width="135px"
                                            v-if="project.analysis === '标准分析' && project.analysisChoiceList.length > 0 && !(project.analysisChoiceList.includes('标准分析') && project.analysisChoiceList.length === 1)">
                                            <el-checkbox-group disabled v-model="project.analysisList"
                                                v-if="project.multipleChoice">
                                                <el-checkbox
                                                    v-for="(choiceItem, choiceIndex) in project.analysisChoiceList"
                                                    :key="choiceIndex" :label="choiceItem"></el-checkbox>
                                            </el-checkbox-group>
                                            <el-radio-group disabled v-model="project.analysisList[0]"
                                                v-if="!project.multipleChoice">
                                                <el-radio
                                                    v-for="(choiceItem, choiceIndex) in project.analysisChoiceList"
                                                    :key="choiceIndex" :label="choiceItem"></el-radio>
                                            </el-radio-group>
                                        </el-form-item>
                                    </div>
                                </div>
              
                                <div style="display: flex;margin-left: 10px;width: 10%!important;">
                                    <el-checkbox :label="project"
                                        :disabled="project.projectStatus === 'TERMINATION'"
                                        @change="handleProjectCheckChange(project)">终止该项目</el-checkbox>
                                </div>
                            </div>
                        </el-checkbox-group>
                    </div>
                    <!-- 硬盘选购信息（可编辑终止金额、软删除/恢复） -->
                    <div v-if="formContract?.hardDiskPurchaseInfo?.length > 0" class="hard-disk-table">
                        <div class="section-header-bar" style="margin-bottom:8px;padding:8px 12px;">
                            <span style="font-weight:600">硬盘选购信息</span>
                        </div>
                        <div class="hard-disk-row hard-disk-header">
                            <div class="hard-disk-cell" style="width:180px;">硬盘大小</div>
                            <div class="hard-disk-cell" style="width:180px;">数量</div>
                            <div class="hard-disk-cell" style="width:160px;">原金额</div>
                            <div class="hard-disk-cell" style="width:160px;">结算金额</div>
                            <div class="hard-disk-cell" style="width:160px;">状态</div>
                        </div>
                        <div v-for="(item, idx) in (formContract.hardDiskPurchaseInfo || [])" :key="idx" class="hard-disk-row">
                            <div class="hard-disk-cell" style="width:180px;">{{ item.hardDiskSize || '-' }}</div>
                            <div class="hard-disk-cell" style="width:180px;">{{ item.sampleCount || '-' }}</div>
                            <div class="hard-disk-cell" style="width:160px;">{{ formatAmount(item.projectAmount) }}</div>
                            <div class="hard-disk-cell" style="width:160px;">
                                <el-input size="small" v-model.number="item.modifiedAmount" :disabled="form.contractTerminateFlag || form.checkProject.length <= 0 || item._deleted"
                                    @change="handleHardDiskAmountChange(item)" placeholder="请输入金额"></el-input>
                            </div>
                            <div class="hard-disk-cell hard-disk-cell-status" style="width:160px;">
                                <el-tag v-if="item._deleted" type="info" size="small" style="margin-right: 10px;">已删除</el-tag>
                                <el-button size="mini" type="danger" plain v-if="!item._deleted && !form.contractTerminateFlag && form.checkProject.length > 0"
                                    @click="toggleHardDiskDeleted(item)">删除</el-button>
                                <el-button size="mini" type="primary" plain v-if="item._deleted" @click="toggleHardDiskDeleted(item)">恢复</el-button>
                            </div>
                        </div>
                    </div>
                    
                    <div v-if="formContract.contractType !== 'DEVELOPMENT'" style="width: 100%;display: flex;">
                        <div v-if="['预付款扣款（测序分析）', '测序分析'].includes(formContract.projectType) && formContract?.moreAnalysis.includes('SENIOR_ANALYSIS')"
                            style="width: 45%;display: flex;">
                            <el-form-item label="高级分析金额" prop="seniorAnalysisAmount" style="width: 100%!important;"
                                :rules="[{ required: form.checkProject.length > 0, message: '请输入高级分析最终结算金额', trigger: 'change' },
                                { validator: (rule, value, callback) => checkMinMax(rule, value, callback, 0, ''), trigger: 'change' }]">
                                <el-input v-model="formContract.seniorAnalysisAmount" auto-complete="off"
                                    :disabled="form.checkProject.length <= 0" placeholder="请输入"></el-input>
                            </el-form-item>
                        </div>
                        <div v-if="['预付款扣款（测序分析）', '测序分析'].includes(formContract.projectType) && formContract?.moreAnalysis.includes('CUSTOMIZED_ANALYSIS')"
                            style="width: 45%;display: flex;">
                            <el-form-item label="个性化分析金额" prop="customizedAnalysisAmount" style="width: 100%!important;"
                                :rules="[{ required: form.checkProject.length > 0, message: '请输入个性化分析最终结算金额', trigger: 'change' },
                                { validator: (rule, value, callback) => checkMinMax(rule, value, callback, 0, ''), trigger: 'change' }]">
                                <el-input v-model="formContract.customizedAnalysisAmount" auto-complete="off"
                                    :disabled="form.checkProject.length <= 0" placeholder="请输入"></el-input>
                            </el-form-item>
                        </div>
                    </div>
                    <el-form-item style="width: 90%!important;" label="合同备注" prop="remark">
                        <el-input :autosize="{ minRows: 3 }" type="textarea" placeholder="请输入内容" disabled
                            v-model="formContract.remark" maxlength="300" show-word-limit>
                        </el-input>
                    </el-form-item>

                </el-form>

            </div>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" class="title" @click="cancel">取消</el-button>
                <el-button size="small" type="success" class="title" @click="handleSubmit">提交</el-button>
            </div>
        </el-dialog>
        <div v-if="loading" class="global-block-overlay" role="presentation" aria-hidden="true">
            <div class="overlay-box">
                <i class="el-icon-loading overlay-spinner" aria-hidden="true"></i>
                <div class="overlay-text">{{ '提交中' }}</div>
            </div>
        </div>
    </div>
</template>

<script>

import { getEvaluators, getPersonById, getPersonByType } from "@/api/dilivery/customer/person";
import { getDataInLocalStorage } from "@/utils/localStorage";
import { getUserById } from "@/api/dilivery/customer/user";
import { getMaterialType } from "@/api/dilivery/material/lexicon";
import { getProjectList } from "@/api/dilivery/project";
import { formatNumberWithUnit } from "@/store/date";
import { checkNumber } from "@/utils/rules";
import { terminateApply, adminTerminate } from "@/api/dilivery/sales/contract";
import { getCompanyPage } from "@/api/dilivery/company";
import { getConfigPage } from "@/api/dilivery/sysconfig";

export default {
    name: "AddTerminate",
    props:{
        showDialog:{
            default:'',
            required: true,
        },
        selectDetail:{
            default:() => ({}),
            required: true,
        },
        type:{
            default:''
        },
        flag:{
            required: true,
            default:''
        }
    },
    data() {
        return {
            gutSalesList: [],
            loading: false,
            specsOption: ['2ml', '5ml'],
            option: [{ label: '全款', value: 'FULL_AMOUNT' }, { label: '2次付款（首付款，尾款）', value: 'TWO_PAYMENTS' }],
            flagOption: [
                { label: '是', value: true },
                { label: '否', value: false },
            ],
            AnalysisEvaluate: [],
            businessOption: [],
            LexiconOptions: [],
            ProjectOption: [],
            TypeOption: [
                { label: 'NGS', name: '二代测序', disabled: [] },
                { label: 'AMPLICON', name: '扩增子测序', disabled: [] },
                { label: 'TGG', name: '三代测序', disabled: [] },
                { label: 'METAPRO', name: '蛋白代谢组测序', disabled: [] },
                { label: '硬盘购买', name: '硬盘购买', disabled: [] },
                { label: 'PCR', name: '其他', disabled: ['裸测', '预付款扣款（裸测）'] },
                { label: 'IGUT', name: 'IGUT', disabled: ['测序分析', '预付款扣款（测序分析）'] },
            ],
            userData: {},
            role: '',
            DateOptions: [
                { label: '1', name: '1年' },
            ],
            title: '合同终止申请',
            UserOptions: [],
            DrafterOptions: [],
            TypeOptions: [
                { label: 'PREPAYMENTS', name: '预付款' },
                { label: 'FORMAL', name: '正式' },
                { label: 'CHARGEBACKS', name: '扣款' }, 
                { label: 'DEVELOPMENT', name: '研发' }
            ],
            form: {
                id: '',
                auditType: 'CONTRACT_TERMINATE_AUDIT',
                contractAmount: '',
                projectMainTypeIdAmount: {},
                diskTypesAmount: {},
                experimentalProcessItems: {},
                reasonForTermination: '',
                contractTerminateFlag: false,
                checkProject:[],
                moreAnalysisRequest: {},
                returnSampleBo: {
                    returnSampleFlag: false,
                    returnSampleAmount: ''
                }
            },
            formContract: {
                generateContractInfo: {
                    extractionFlag: false,
                    watermarkFlag: false,
                    returnSampleBo: {
                        reason: '',
                        returnSampleAmount: 0,
                        returnSampleFlag: false
                    },
                    paymentMethods: {}
                },
                sampleManagement: null,
                watermarkFlag: false,
                extractionFlag: false,
                returnSampleAmount: {},
                methods: 'FULL_AMOUNT',
                theFirstRatio: '',
                moreAnalysisRequest: {},
                returnFlag: false,
                sampleAmount: 0,
                reason: '',
                specificProjectType: [
                    {
                        dataAmountUnit: '',                // 数据量单位
                        experimentalProcessItems: [],      // 实验过程项
                        experimental: [],                  // 实验过程
                        sequencingPlatform: '',            // 二代检测平台
                        sequencingPlatformList: [],        // 二代平台选项
                        thirdSequencingPlatform: '',       // 三代检测平台
                        tesThirdSequencingPlatform: '',
                        thirdSequencingPlatformList: [],   // 三代平台选项
                        projectSampleDataList: [],         // 样品数据列表
                        minSampleCount: '',
                        maxSampleCount: '',
                        projectMainTypeId: '',
                        projectType: '',
                        projectClassification: '',
                        numberOfSamples: 0,
                        projectAmount: 0,
                        projectNewAmount: 0,
                        sizeOfSampleData: {},
                        analysisList: [],
                        analysis: '标准分析',
                        multipleChoice: false,
                        analysisChoiceList: [],
                        labList: [],
                        analyzeRequirements: ''
                    }
                ],
                moreAnalysis: [],
                analysisRequest: 'STANDARD_ANALYSIS',
                pureAnalysisEvaluateId: '',
                seniorAnalysisAmount: 0,
                customizedAnalysisAmount: 0,
                protectiveFluidInfo: {
                    protectiveFluidMethod: '',
                    doorInfo: {
                        doorTime: '',
                        doorFee: '',
                        phone: '',
                        address: ''
                    },
                    materialMailInfo: {
                        mailTime: '',
                        recipient: '',
                        phone: '',
                        address: ''
                    }
                }, 
                expirationDate: '1',
                contractType: 'FORMAL',
                contractDraftingDate: '',
                contractAmount: 0,
                salesId: '',
                customerContactsId: '',
                addedAmount: 0,
                signingDate: '',
                signingPlace: '上海',
                contractNumber: '',
                contractName: '',
                trusteeCompanyId: '1',
                trusteeContactsId: '',
                projectType: '测序分析',
                remark: ''
            },
        }
    },
    computed: {
        projectTypeList() {
            return this.formContract.specificProjectType.map(item => item.projectType)
        },
        maxAmount() {
            return this.formContract.specificProjectType.map(item => {
                let amount
                if (this.form.checkProject.includes(item)) {
                    // 实验过程构成金额的项目取各实验过程结算额之和，普通项目取最终结算金额
                    amount = this.isExperimentalProject(item) ? this.sumSettledExperimentalAmount(item) : Number(item.projectNewAmount)
                } else {
                    amount = Number(item.projectAmount)
                }
                return amount > 0 ? amount : 0
            }).reduce((sum, amount) => sum + amount, 0)
        },
        customerContact() {
            return this.UserOptions.find(item => item.id === this.formContract.customerContactsId)
        },
        projectTypeData() {
            return ['测序分析', '裸测', '预付款扣款（测序分析）', '预付款扣款（裸测）',]
        },
        hardDiskList() {
            return ['预付款扣款（测序分析）', '预付款扣款（裸测）', '测序分析', '裸测', '预付款扣款（纯分析）', '纯分析', '预付款扣款（返样/暂存样品）', '返样/暂存样品', '预付款扣款（其他）', '其他']
        },
        // AnalysisEvaluateOptions() {
        //     if (this.formContract.contractType === 'DEVELOPMENT') {
        //         return this.AnalysisEvaluate.filter(item => item.name === '程燕')
        //     } else {
        //         return this.AnalysisEvaluate
        //     }
        // },
        DirectionOptions() {
            const directions = [
                
                { label: '微生态保护剂', check: true },
                { label: '肠道菌群检测样本采集套装（16s全长）', check: false },
                { label: '肠道菌群检测样本采集套装（宏基因组）', check: false },
                { label: 'RNA保护剂', check: true },
            ].filter(item => this.userData.personUuids.some(it => this.gutSalesList.includes(it)) || this.role === 'ADMIN' || item.check);
            if (this.formContract.contractType === 'PREPAYMENTS') {
                return [
                    { label: '预付款' },
                ]
            } else if (['FORMAL'].includes(this.formContract.contractType)) {
                return [
                    { label: '测序分析' },
                    { label: '裸测' },
                    { label: '纯分析' },
                    { label: '返样/暂存样品' },
                    ...directions,
                    { label: '数据库、服务器、系统流程开发和部署' },
                    { label: '培训服务' },
                    { label: '其他' }
                ]
            } else if (this.formContract.contractType === 'CHARGEBACKS') {
                return [
                    { label: '预付款扣款（测序分析）' },
                    { label: '预付款扣款（裸测）' },
                    { label: '预付款扣款（纯分析）' },
                    { label: '预付款扣款（返样/暂存样品）' },
                    ...directions,
                    { label: '预付款扣款（数据库、服务器、系统流程开发和部署）' },
                    { label: '预付款扣款（培训服务）' },
                    { label: '预付款扣款（其他）' },
                ]
            } else if (this.formContract.contractType === 'DEVELOPMENT') {
                return [
                    { label: '测序分析' },
                    ...directions,
                    { label: '纯分析' },
                    { label: '裸测' },
                ]
            } else {
                return []
            }
        },
        seniorAnalysisAmount() {
            if (!this.formContract.moreAnalysis.includes('SENIOR_ANALYSIS')) {
                return 0
            }
            if (!['预付款扣款（测序分析）', '测序分析'].includes(this.formContract.projectType)) {
                return 0
            }
            return Number(this.formContract.seniorAnalysisAmount)
        },
        customizedAnalysisAmount() {
            if (!this.formContract.moreAnalysis.includes('CUSTOMIZED_ANALYSIS')) {
                return 0
            }
            if (!['预付款扣款（测序分析）', '测序分析'].includes(this.formContract.projectType)) {
                return 0
            }
            return Number(this.formContract.customizedAnalysisAmount)
        },
        hardDiskPurchaseAmount() {
            const list = this.formContract.hardDiskPurchaseInfo || []
            return list.reduce((sum, item) => {
                if (item && item._deleted) return sum
                const amount = Number(item.modifiedAmount)
                return sum + (!isNaN(amount) && amount >= 0 ? amount : 0)
            }, 0)
        },
        hasDissociationDelivery() {
            const dissociationTypes = ['单细胞解离转录组-C4', '单细胞解离转录组-10X', '单细胞解离转录组']
            return dissociationTypes.some(item => this.formContract.specificProjectType.map(project => project.projectType).includes(item))
                && this.formContract.protectiveFluidInfo?.protectiveFluidMethod
        },
        protectiveFluidMethodLabel() {
            const map = {
                DOOR: '上门',
                MAIL: '邮寄'
            }
            return map[this.formContract.protectiveFluidInfo?.protectiveFluidMethod] || ''
        }
    },
    watch: {
        selectDetail: {
            async handler(newVal) {
                if (newVal && Object.keys(newVal).length > 0) {
                    this.form.id = newVal.id
                    let tempData = JSON.parse(JSON.stringify(newVal))
                    let contract = JSON.parse(JSON.stringify(this.formContract))
                    this.formContract = {
                        ...contract,
                        ...tempData,
                        salesId: newVal?.sales?.uuid ?? '',
                        trusteeContactsId: newVal?.trusteeContacts?.uuid ?? '',
                        analysisRequest: 'STANDARD_ANALYSIS',
                    }
                    if (this.formContract.generateContractInfo === null) {
                        this.formContract.generateContractInfo = {}
                    }
                    if (!this.formContract.protectiveFluidInfo) {
                        this.formContract.protectiveFluidInfo = {
                            protectiveFluidMethod: '',
                            doorInfo: null,
                            materialMailInfo: null
                        }
                    }
                    if (!this.formContract.protectiveFluidInfo.doorInfo) {
                        this.formContract.protectiveFluidInfo.doorInfo = {
                            doorFee: '',
                            phone: '',
                            address: '',
                            doorTime: ''
                        }
                    }
                    if (!this.formContract.protectiveFluidInfo.materialMailInfo) {
                        this.formContract.protectiveFluidInfo.materialMailInfo = {
                            recipient: '',
                            phone: '',
                            address: '',
                            mailTime: '',
                        }
                    }
                    this.formContract.returnFlag = !!newVal['generateContractInfo']?.['returnSampleBo']?.['returnSampleFlag']
                    this.formContract.sampleAmount = (newVal['generateContractInfo']?.['returnSampleBo']?.['returnSampleAmount']) ?? 0
                    this.formContract.reason = (newVal['generateContractInfo']?.['returnSampleBo']?.['reason']) ?? ''

                    const paymentMethods = (newVal['generateContractInfo']?.paymentMethods) ?? {}
                    const methodKey = Object.keys(paymentMethods)
                    const methodValues = Object.values(paymentMethods)
                    if (methodKey.length) {
                        this.formContract.methods = methodKey[0]
                    }
                    if (methodValues.length) {
                        this.formContract.theFirstRatio = Number(methodValues[0]) * 100
                    }

                    if (newVal.moreAnalysisRequest) {
                        for (let request in newVal.moreAnalysisRequest) {
                            switch (request) {
                                case 'SENIOR_ANALYSIS':
                                    this.formContract.seniorAnalysisAmount = newVal.moreAnalysisRequest[request]
                                    break;
                                case 'CUSTOMIZED_ANALYSIS':
                                    this.formContract.customizedAnalysisAmount = newVal.moreAnalysisRequest[request]
                                    break;
                                default:
                                    break
                            }
                        }
                    }
                    this.getUserOption(this.formContract.salesId)
                    await this.getProjectOption()
                    this.formContract.specificProjectType.forEach((item, index) => {
                        if (!item.labList) {
                            this.$set(item, 'labList', []);
                        }
                        if (!item.experimentalProcessItems) {
                            this.$set(item, 'experimentalProcessItems', []);
                        }
                        item.projectSampleDataList.forEach((dataItem, dataIndex) => {
                            this.$set(dataItem, 'projectList', this.getSizeList(item.projectClassification, item.projectType, dataItem.sizeOfSampleData));
                        })
                        const project = this.ProjectOption.find(itemA => itemA.name === item.projectType);
                        const analysisChoiceList = project?.attribute?.optionalAnalysisType?.split('/')?.filter(item => item !== '') ?? []
                        if (project?.attribute) {
                            this.$set(item, 'dataAmountUnit', project.attribute.dataAmountUnit ?? '');
                            this.$set(item, 'minSampleCount', project.attribute.minSampleCount);
                            this.$set(item, 'maxSampleCount', project.attribute.maxSampleCount);
                            this.$set(item, 'multipleChoice', project.attribute.multipleChoice);
                            this.$set(item, 'analysisChoiceList', analysisChoiceList);
                            if (project.attribute.labProcess) {
                                let list = project.attribute?.labProcess?.split('/')?.filter(item => item !== '') ?? []
                                for (let items of ['引物合成', '荧光定量']) {
                                    const index1 = list.indexOf(items)
                                    if (index1 !== -1) {
                                        list.splice(index1, 1)
                                        list.unshift(items)
                                    }
                                }
                                // 深拷贝原始实验过程项，保留原金额 originalExperimentAmount，使 experimental 与 experimentalProcessItems 相互独立（编辑结算金额不污染原始数据）
                                let experimental = (item.experimentalProcessItems || []).map(o => ({
                                    ...o,
                                    originalExperimentAmount: o.experimentAmount
                                }))
                                let map = experimental.map(item => item.experimentName)
                                for (let info of list) {
                                    if (map.includes(info)) {
                                        continue
                                    }
                                    let lab = {
                                        experimentName: info,
                                        numberOfExperiment: '',
                                        experimentAmount: '',
                                        originalExperimentAmount: ''
                                    }
                                    experimental.push(lab)
                                }
                                this.$set(item, 'experimental', experimental);
                            } else {
                                this.$set(item, 'experimental', []);
                            }
                        } else {
                            this.$set(item, 'dataAmountUnit', '');
                            this.$set(item, 'minSampleCount', '');
                            this.$set(item, 'maxSampleCount', '');
                            this.$set(item, 'multipleChoice', false);
                            this.$set(item, 'analysisChoiceList', []);
                            this.$set(item, 'experimental', []);
                        }

                        const analyzeRequirements = item?.analyzeRequirements?.split('/')?.filter(it => it !== '') ?? []

                        if (analyzeRequirements.includes('非标准分析')) {
                            this.$set(item, 'analysis', '非标准分析');
                        } else {
                            this.$set(item, 'analysis', '标准分析');
                        }
                        // 标准分析具体类型：回显值构成的数组属于该项目可选项时按其勾选，反之为空
                        if (analyzeRequirements.every(it => (item.analysisChoiceList || []).includes(it))) {
                            this.$set(item, 'analysisList', analyzeRequirements);
                        } else {
                            this.$set(item, 'analysisList', []);
                        }
                        this.$set(item, 'labList', item?.experimentalProcessItems?.map(item => item.experimentName) ?? []);
                        for (let items of ['引物合成', '荧光定量']) {
                            if (item.experimental.map(item => item.experimentName).includes(items) && !item.labList.includes(items)) {
                                item.labList.push(items)
                            }
                        }
                        if (!['其他', '硬盘购买'].includes(item.projectClassification)) {
                            if (item.projectClassification === 'AMPLICON') {
                                switch (project?.modelAttr?.sonModel) {
                                    case 'SECOND':
                                        this.$set(item, 'sequencingPlatformList', project?.attribute?.sequencingPlatform?.split('/')?.filter(item => item !== '') ?? []);
                                        this.$set(item, 'thirdSequencingPlatformList', []);
                                        break
                                    case 'THIRD':
                                        this.$set(item, 'sequencingPlatformList', []);
                                        this.$set(item, 'thirdSequencingPlatformList', project?.attribute?.sequencingPlatform?.split('/')?.filter(item => item !== '') ?? []);
                                        break
                                    default:
                                        this.$set(item, 'sequencingPlatformList', []);
                                        this.$set(item, 'thirdSequencingPlatformList', []);
                                        break
                                }
                            } else {
                                this.$set(item, 'sequencingPlatformList', project?.attribute?.sequencingPlatform?.split('/')?.filter(item => item !== '') ?? []);
                                this.$set(item, 'thirdSequencingPlatformList', project?.attribute?.thirdSequencingPlatform?.split('/')?.filter(item => item !== '') ?? []);
                            }

                            if (!item.sequencingPlatform && item.sequencingPlatformList.length > 0) {
                                this.$set(item, 'sequencingPlatform', item.sequencingPlatformList[0]);
                            }
                            if (item.sequencingPlatformList.length === 0) {
                                this.$set(item, 'sequencingPlatform', '');
                            }
                            if (!item.thirdSequencingPlatform && item.thirdSequencingPlatformList.length > 0) {
                                if (item.thirdSequencingPlatformList.includes('纳米孔')) {
                                    this.$set(item, 'thirdSequencingPlatform', '纳米孔');
                                    this.$set(item, 'tesThirdSequencingPlatform', '纳米孔');
                                } else {
                                    this.$set(item, 'thirdSequencingPlatform', item.thirdSequencingPlatformList[0]);
                                    this.$set(item, 'tesThirdSequencingPlatform', item.thirdSequencingPlatformList[0]);
                                }
                            }
                            if (item.thirdSequencingPlatformList.length === 0) {
                                this.$set(item, 'thirdSequencingPlatform', '');
                                this.$set(item, 'tesThirdSequencingPlatform', '');
                            }
                        } else {
                            this.$set(item, 'sequencingPlatformList', []);
                            this.$set(item, 'thirdSequencingPlatformList', []);
                        }
                    })
                    this.$set(this.formContract, 'moreAnalysis', Object.keys(newVal.moreAnalysisRequest));

                    // 初始化硬盘选购信息的可编辑字段和软删除标记
                    const hdList = this.formContract.hardDiskPurchaseInfo || []
                    hdList.forEach(hd => {
                        if (hd && typeof hd === 'object') {
                            if (hd.projectAmount === undefined) hd.projectAmount = hd.projectAmount || 0
                            this.$set(hd, '_deleted', false)
                            this.$set(hd, 'modifiedAmount', Number(hd.projectAmount))
                        }
                    })

                }
            },
            immediate: true
        },
        flag: {
            handler(newVal) {
                if (newVal) {
                    if (newVal === 'contract') {
                        this.form.contractTerminateFlag = true
                        if (this.type) {
                            this.title = '合同终止'
                        } else {
                            this.title = '合同终止申请'
                        }
                    } else {
                        this.form.contractTerminateFlag = false
                        if (this.type) {
                            this.title = '实验终止'
                        } else {
                            this.title = '实验终止申请'
                        }
                    }
                }
            },
            immediate: true
        }
    },
    created() {
        this.userData = JSON.parse(getDataInLocalStorage('user'))
        this.role = getDataInLocalStorage('role')
    },
    mounted() {
        this.getGutSales()
        this.getDrafterOption()
        // this.getAnalysisEvaluate()
        this.getLexiconOptions()
        this.getBusinessOption();
    },
    methods: {
        getGutSales() {
            getConfigPage({}, {}).then(res => {
                this.gutSalesList = []
                if (res.code === 200) {
                    const form = res.data.records.find(item => item.name === 'SYS_CONTRACT_GUT_SALES')
                    if (form) {
                        this.gutSalesList = form.confValue.split(',')
                    }
                }
            }).catch(() => {
                this.gutSalesList = []
            })
        },
        getBusinessOption() {
            try {
                let params = {
                    'page.current': 1,
                    'page.size': 500,
                    'order': 'id.asc'
                }
                getCompanyPage(params, {}).then(res => {
                    if (res.code === 200) {
                        this.businessOption = res.data.records.filter(item => item['companyInvoiceStatus'])
                    }
                }).catch(err => { })
            } catch (error) {
                console.log(error);
                this.$messageUi.error('获取公司信息失败');
            }
        },
        checkMinMax(rule, value, callback, min, max){
            if (value && isNaN(value)) {
                return callback(new Error('请输入数字值'));
            }
            if (value < 0) {
                return callback(new Error('输入值必须大于等于0'));
            }
            if (min && value < min) {
                return callback(new Error(`输入值必须不小于 ${min}`));
            }
            if (max && value > max && this.flag !== 'contract') {
                return callback(new Error(`输入值必须小于等于原合同金额 ${max}`));
            }
            return callback();
        },
        //校验实验过程结算金额：必须为数字，且 0 <= 结算金额 <= 原金额
        checkExperimentAmount(rule, value, callback, originalAmount) {
            if (value === '' || value === null || value === undefined) {
                return callback()
            }
            if (isNaN(value)) {
                return callback(new Error('请输入数字值'))
            }
            const num = Number(value)
            if (num < 0) {
                return callback(new Error('结算金额必须大于等于0'))
            }
            const max = Number(originalAmount)
            if (!isNaN(max) && num > max) {
                return callback(new Error(`结算金额必须小于等于原金额 `))
            }
            return callback()
        },
        validateForm(ref) {
            return new Promise((resolve) => {
                this.$refs[ref]['validate']((valid) => {
                    resolve(valid);
                });
            });
        },
        validateContractAmount() {
            if (this.formContract.contractType === 'DEVELOPMENT') {
                return { valid: true, message: '' }
            }

            const contractAmount = Number(this.formContract.contractAmount || 0)
            const hardDiskPurchaseAmount = Number(this.hardDiskPurchaseAmount || 0)
            const sampleAmount = (this.projectTypeData.includes(this.formContract.projectType) && this.formContract.returnFlag && this.formContract.contractType !== 'DEVELOPMENT') ? Number(this.formContract.sampleAmount || 0) : 0
            const doorFee = ['单细胞解离转录组-C4', '单细胞解离转录组-10X', '单细胞解离转录组'].some(item => this.formContract.specificProjectType.map(project => project.projectType).includes(item)) && this.formContract.protectiveFluidInfo.protectiveFluidMethod === 'DOOR' ? Number(this.formContract.protectiveFluidInfo.doorInfo.doorFee || 0) : 0

            if (this.projectTypeData.includes(this.formContract.projectType)) {
                if (['预付款扣款（测序分析）', '测序分析'].includes(this.formContract.projectType)) {
                  
                    const expectedAmount = this.seniorAnalysisAmount + this.customizedAnalysisAmount + Number(this.maxAmount || 0) + hardDiskPurchaseAmount + sampleAmount + doorFee
                    if (expectedAmount !== contractAmount) {
                        return { valid: false, message: '项目与分析总金额不等于合同金额，请检查' }
                    }
                } else {
                    const expectedAmount = Number(this.maxAmount || 0) + hardDiskPurchaseAmount + sampleAmount + doorFee
                    if (expectedAmount !== contractAmount) {
                        return { valid: false, message: '项目总金额不等于合同金额，请检查' }
                    }
                }
            } else if (this.hardDiskList.includes(this.formContract.projectType)) {
                if (!(contractAmount >= hardDiskPurchaseAmount)) {
                    return { valid: false, message: '合同金额必须大于等于硬盘总金额，请检查' }
                }
            }

            return { valid: true, message: '' }
        },
        async handleSubmit() {
            if (!this.form.contractTerminateFlag) {
                const validation = this.validateContractAmount()
                if (!validation.valid) {
                    this.$messageUi.error(validation.message)
                    return
                }
                if (this.form.checkProject.length === 0) {
                    this.$messageUi.error('请选择需要终止的项目')
                    return
                }
                this.form.contractAmount = this.formContract.contractAmount
                this.form.projectMainTypeIdAmount = {}
                this.form.diskTypesAmount = {}
                this.form.experimentalProcessItems = {}
                for (const item of this.form.checkProject) {
                    if (this.isExperimentalProject(item) && item.projectMainTypeId) {
                        // 实验过程构成金额的项目：仅提交实验过程结算明细（Map<项目id, List<实验过程项>>），不计入 projectMainTypeIdAmount
                        this.form.experimentalProcessItems[item.projectMainTypeId] = this.getSettledExperimentalItems(item)
                    } else if (item.projectMainTypeId) {
                        this.form.projectMainTypeIdAmount[item.projectMainTypeId] = item.projectNewAmount
                    } else {
                        this.form.diskTypesAmount[item.projectType] = item.projectNewAmount
                    }
                }
                // 包含硬盘选购信息（排除已软删除条目）
                const hdList = this.formContract.hardDiskPurchaseInfo || []
                this.form.hardDiskPurchaseInfo = hdList.filter(hd => hd && !hd._deleted).map(hd => ({
                    projectAmount: Number(hd.modifiedAmount),
                    hardDiskSize: hd.hardDiskSize,
                    sampleCount: hd.sampleCount,
                }))
                this.form.returnSampleBo = {
                    returnSampleFlag: this.formContract.returnFlag,
                    returnSampleAmount: this.formContract.sampleAmount,
                    reason: this.formContract.reason
                }
                this.form.moreAnalysisRequest = this.formContract.moreAnalysis.reduce((acc, item) => {
                    if (item === 'SENIOR_ANALYSIS') {
                        acc[item] = this.formContract.seniorAnalysisAmount
                    } else if (item === 'CUSTOMIZED_ANALYSIS') {
                        acc[item] = this.formContract.customizedAnalysisAmount
                    }
                    return acc
                }, {})
            }
            
            // 表单验证
            const [contractFormValid, FormValid] = await Promise.all([
                this.validateForm('formContract'),
                this.validateForm('form')
            ]);
            if (contractFormValid && FormValid) {
                let ApiMethod = terminateApply
                if (this.type === 'admin') {
                    ApiMethod = adminTerminate
                }
                ApiMethod(this.form).then(res => {
                    if (res.code === 200) {
                        this.$store.commit('right/setChangeRed', true)
                        if (['APPLYING', 'DEFEAT'].includes(this.selectDetail.status) || this.type === 'admin') {
                            this.$messageUi.success('合同已终止!')
                        } else {
                            this.$messageUi.success('已申请合同终止!')
                        }
                        this.$emit('submit', 'confirm')
                    }
                }).catch(err => {
                    console.log(err);
                })
            } else {
                this.$nextTick(() => {
                    let err = document.getElementsByClassName('is-error')
                    if (err.length) {
                        err[0].scrollIntoView({
                            block: 'center',
                            behavior: 'smooth',
                        })
                    }
                })
                this.$messageUi.error('填写参数不规范，请检查')
            }
        },
        checkNumber,
        //判断项目金额是否由实验过程构成（存在原始实验过程项）
        isExperimentalProject(project) {
            return !!project && Array.isArray(project.experimentalProcessItems) && project.experimentalProcessItems.length > 0
        },
        //判断某实验过程项是否可结算（属于原始实验过程项）
        isSettleableExperiment(project, experimentName) {
            if (!this.isExperimentalProject(project)) return false
            return project.experimentalProcessItems.some(item => item.experimentName === experimentName)
        },
        //构建最终结算的实验过程数据：以原始实验过程项为基础，仅用编辑后的 experimentAmount 覆盖，其余字段保持不变
        getSettledExperimentalItems(project) {
            const original = Array.isArray(project.experimentalProcessItems) ? project.experimentalProcessItems : []
            const edited = Array.isArray(project.experimental) ? project.experimental : []
            return original.map(orig => {
                const target = edited.find(item => item.experimentName === orig.experimentName)
                return {
                    ...orig,
                    experimentAmount: target ? target.experimentAmount : orig.experimentAmount
                }
            })
        },
        //实验过程结算金额之和
        sumSettledExperimentalAmount(project) {
            return this.getSettledExperimentalItems(project).reduce((sum, item) => {
                const amount = Number(item.experimentAmount)
                return sum + (!isNaN(amount) && amount > 0 ? amount : 0)
            }, 0)
        },
        //实验过程金额变更时联动刷新该项目最终结算金额（=各实验过程结算额之和）
        handleExperimentAmountChange(project) {
            if (this.isExperimentalProject(project)) {
                this.$set(project, 'projectNewAmount', this.sumSettledExperimentalAmount(project))
            }
        },
        //勾选终止项目时，实验过程项目初始化最终结算金额为各实验过程结算额之和
        handleProjectCheckChange(project) {
            this.$nextTick(() => {
                if (this.form.checkProject.includes(project) && this.isExperimentalProject(project)) {
                    this.$set(project, 'projectNewAmount', this.sumSettledExperimentalAmount(project))
                }
            })
        },
        //获取所有的项目类型
        async getProjectOption() {
            try {
                const res = await getProjectList({})
                if (res.code === 200) {
                    this.ProjectOption = res.data.filter(item => !item.deprecated)
                }
            } catch (error) { console.log(error); }
        },


        returnList(keys, data) {
            const order = ['NGS', 'PACBIO', 'HIC', 'ONT'];
            return Object.entries(keys).map(([key, value]) => {
                let name;
                switch (key) {
                    case "NGS":
                        name = "二代";
                        break;
                    case "PACBIO":
                        name = "三代";
                        break;
                    case "HIC":
                        name = "HIC";
                        break;
                    case "ONT":
                        name = "ONT";
                        break;
                    default:
                        name = ""; // 如果 key 不在预定义的列表中，name 为空字符串
                }
                let boolean = false;
                if (data && Object.values(data).length > 0) {
                    boolean = !!data[key];
                } else {
                    boolean = value !== "NOT";
                }
                return {
                    key: key,
                    value: value,
                    size: (data && data[key]) ? formatNumberWithUnit(Number(data[key])) : "",
                    boolean: boolean,
                    name: name // 添加 name 属性
                };
            }).sort((a, b) => order.indexOf(a.key) - order.indexOf(b.key));
        },
        getSizeList(type, name, sizeOfSampleData) {
            if (type === '' || name === '') {
                return []
            }
            if (sizeOfSampleData) {
                return this.returnList(sizeOfSampleData, sizeOfSampleData)
            }
            const project = this.ProjectOption.find(item => item.model === type && item.name === name)
            if (project && project['geneSequencingSetting']) {
                return this.returnList(project['geneSequencingSetting'], sizeOfSampleData)
            } else {
                return []
            }
        },
        filterOptions(type, project) {
            const HARD_DISK_OPTIONS = [
                { model: '硬盘购买', name: '1T', deprecated: false },
                { model: '硬盘购买', name: '2T', deprecated: false },
                { model: '硬盘购买', name: '4T', deprecated: false },
                { model: '硬盘购买', name: '5T', deprecated: false },
                { model: '硬盘购买', name: '6T', deprecated: false },
                { model: '硬盘购买', name: '8T', deprecated: false },
                { model: '硬盘购买', name: '10T', deprecated: false },
                { model: '硬盘购买', name: '12T', deprecated: false },
                { model: '硬盘购买', name: '16T', deprecated: false },
                { model: '硬盘购买', name: '20T', deprecated: false }
            ];
            if (!type) {
                return [];
            }
            const options = type === '硬盘购买' ? HARD_DISK_OPTIONS : this.ProjectOption;
            const filterCondition = (item) => {
                return item.model === type && (!this.projectTypeList.includes(item.name) || (project && item.name === project));
            };
            return options.filter(filterCondition);
        },
        async getLexiconOptions() {
            try {
                let param = {
                    'type': 'PROTECT_REAGENT'
                }
                const res = await getMaterialType(param)
                if (res.code === 200) {
                    this.LexiconOptions = res.data.filter(item => item.number !== 0 && item['materialStatus'])
                }
            } catch (error) {
                console.log(error);
            }
        },
        // getAnalysisEvaluate() {
        //     getEvaluators().then(res => {
        //         if (res.code === 200) {
        //             this.AnalysisEvaluate = res.data
        //         }
        //     }).catch(err => {
        //     })
        // },
        addAllAmount() {
            if (this.formContract.contractType === 'DEVELOPMENT') {
                this.formContract.contractAmount = 0
                return
            }
            const maxAmount = (this.projectTypeData.includes(this.formContract.projectType)) ? Number(this.maxAmount) : 0
            const hardDiskPurchaseAmount = (this.hardDiskList.includes(this.formContract.projectType)) ? Number(this.hardDiskPurchaseAmount || 0) : 0
            const sampleAmount = (this.projectTypeData.includes(this.formContract.projectType) && this.formContract.returnFlag) ? Number(this.formContract.sampleAmount) : 0
     
            const hasDoorFee = () => ['单细胞解离转录组-C4', '单细胞解离转录组-10X', '单细胞解离转录组'].some(item => this.formContract.specificProjectType.map(project => project.projectType).includes(item)) && this.formContract.protectiveFluidInfo.protectiveFluidMethod === 'DOOR' && this.projectTypeData.includes(this.formContract.projectType)

            const doorFee = hasDoorFee() ? Number(this.formContract.protectiveFluidInfo.doorInfo.doorFee) : 0

            this.formContract.contractAmount = this.seniorAnalysisAmount + this.customizedAnalysisAmount + maxAmount + hardDiskPurchaseAmount + sampleAmount + doorFee
        },
        getUserOption(salesId) {
            try {
                getUserById(salesId).then(res => {
                    if (res.code === 200) {
                        this.UserOptions = res.data;
                    }
                }).catch(err => { })
            } catch (error) {
                console.log(error);
                this.$messageUi.error('获取客户信息失败');
            }
        },
        getDrafterOption() {
            try {
                if (['ADMIN', 'MANAGER', 'SALES_ASSI_MANAGER', 'SALES_ASSI'].includes(this.role)) {
                    getPersonByType('SALES', {}).then(res => {
                        if (res.code === 200) {
                            this.DrafterOptions = res.data;
                        }
                    }).catch(err => { })
                } else {
                    getPersonById(this.userData['personUuids'][0], {}).then(res => {
                        if (res.code === 200) {
                            this.DrafterOptions = res.data;
                        }
                    }).catch(err => { })
                }
            } catch (error) {
                console.log(error);
                this.$messageUi.error('获取人员信息失败');
            }
        },
        handleHardDiskAmountChange(item) {
            if (!item) return
            const orig = Number(item.projectAmount || 0)
            let val = Number(item.modifiedAmount)
            if (isNaN(val) || val < 0) {
                this.$messageUi.error('金额请输入大于等于0的数字')
                item.modifiedAmount = orig
                return
            }
            if (val > orig) {
                this.$messageUi.error('结算金额必须不大于原金额')
                item.modifiedAmount = orig
                return
            }
            // 保持为数值
            item.modifiedAmount = val
        },
        toggleHardDiskDeleted(item) {
            if (!item) return
            item._deleted = !item._deleted
            // 若恢复，确保 modifiedAmount 有值且不超原额
            if (!item._deleted) {
                const orig = Number(item.projectAmount || 0)
                if (!item.modifiedAmount && item.modifiedAmount !== 0) item.modifiedAmount = orig
                if (Number(item.modifiedAmount) >= orig) item.modifiedAmount = orig
            }
        },
        formatAmount(value) {
            if (value === null || value === undefined || value === '') return '-'
            const num = Number(value)
            if (Number.isNaN(num)) return value
            return '¥' + num.toLocaleString('zh-CN')
        },
        cancel() {
            this.$emit('submit', 'cancel')
        },
    },
}
</script>

<style lang="scss" scoped>
.global-block-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 10050;
    /* 确保覆盖在所有内容之上 */
    background: rgba(0, 0, 0, 0.35);
    /* 半透明遮罩 */
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: all;
    /* 拦截所有指针事件，阻止下层交互 */
}

/* 中心盒子样式（可按需调整） */
.global-block-overlay .overlay-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 18px 24px;
    border-radius: 8px;
    background: rgba(0, 0, 0, 0);
    /* 使用透明背景，文字/图标为白色 */
    color: #fff;
}

/* 使用 Element 的 loading 图标（el-icon-loading）并放大 */
.overlay-spinner {
    font-size: 40px;
    color: #fff;
}

/* 文字说明 */
.overlay-text {
    margin-top: 10px;
    font-size: 16px;
    color: #fff;
}


.upload-demo {

    /*margin-top: 20px;*/
    width: 100% !important;
}

:deep(.el-upload) {
    display: flex;
    gap: 20px;
    width: 100% !important;
}

@import "@/assets/css/mixins.scss";

.el-dialog-div {
    @include thin-scrollbar(8px, #888);
    max-height: 60vh;
    /* 你还可以在这个类里写其他样式 */
    background: #fff;
}

.invoice-box {
    border: 1px dashed #ccc;
    /* 虚线框 */
    padding: 20px 20px 0 0;
    margin-bottom: 20px;
}

.bold-text {
    font-weight: bold;
    color: red;
    background-color: yellow;
    font-size: 16px;
}

.checkbox-group {
    display: flex;
    flex-wrap: nowrap;
    /* 禁止换行 */
}

/* 使 <el-row> 的高度贴合内部组件 */
.fit-height-row {
    margin: 0 0 0 0;
    display: flex;
    /* 使用 flex 布局 */
    align-items: stretch;
    /* 使子元素的高度自动拉伸 */
    flex-wrap: nowrap;
    /* 防止换行 */
}

.formDiv {
    display: flex;
    flex-wrap: wrap;
}

.el-form-item {
    width: 45% !important;
}

:deep(.el-select) {
    width: 100%;
}

.hard-disk-table {
    width: 100%;
    margin-bottom: 20px;
}

.hard-disk-row {
    display: flex;
    gap: 12px;
    align-items: center;
    padding: 8px;
    border-bottom: 1px dashed #f0f0f0;
}

.hard-disk-row.hard-disk-header {
    font-weight: 600;
    padding: 6px 8px;
    border-bottom: 1px solid #ebeef5;
    background: #fafafa;
}

.hard-disk-cell {
    display: flex;
    justify-content: center;
    align-items: center;
}

.hard-disk-cell-status {
    display: flex;
    justify-content: center;
    align-items: center;
}


.el-form-item__label {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex: 1;
}

.no-border-select :deep(.el-input__inner) {
    border: none;
    box-shadow: none;
    background: transparent;
    /* 背景透明，与表格融合 */
}

.no-border-select :deep(.el-textarea__inner) {
    border: none;
    box-shadow: none;
    background: transparent;
    /* 背景透明，与表格融合 */
}

:deep(.el-input.is-disabled .el-input__icon) {
    display: none;
    background-color: #ffffff !important;
}




.custom-style {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 0 0 0;
    /* 默认不显示上边框 */

}

.disabled-state {
    cursor: not-allowed !important;
    /* 鼠标显示为不可交互状态 */
    filter: grayscale(100%) !important;
    /* 设置为灰色 */
}

.disabled-state :deep(*) {
    pointer-events: none !important;
    cursor: not-allowed !important;
    /* 禁用元素及其子元素的交互 */
}

.first-item {
    border-top: 1px dashed #d9d9d9;
    /* 第一个元素显示上边框 */
}

/* 硬盘选购样式 */
.hard-disk-row {
    display:flex;
    align-items:center;
}
.hard-disk-col {
    padding:6px 8px;
}

/*.formDiv .el*/
</style>
